



















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import avatar from 'vue-avatar';
import { Post as PostModel } from '@/models/forum/post';
import moment from 'moment';
import { vxm } from '@/store.vuex';
import Comment from './Comment.vue';
import AddComment from './AddComment.vue';
import ReportFlag from './ReportFlag.vue';
import PostAction from './PostAction.vue';
import VueToastr from '@deveodk/vue-toastr';
import WlAvatar from '@/components/Commons/WlAvatar.vue';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
import VModal from 'vue-js-modal';
import PostLikeList from './PostLikeList.vue';
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
@Component({
  components: {
    avatar,
    Comment,
    AddComment,
    PostLikeList,
    WlAvatar,
    PostAction,
    ReportFlag,
  },
})
export default class Post extends Vue {
  @Prop({ default: new PostModel() }) details;
  @Prop({ default: false }) isPostDetailsPage;
  @Prop({ default: false }) isHomePage;
  private editPostId: Number = 0;
  private showComment: boolean = false;
  private showOnlyThreeComments = true;
  $wlToastr: any;
  mounted() {
    if (this.isPostDetailsPage) {
      this.showComment = true;
      vxm.forum.listComments({ postId: this.details.postId, initCall: true });
    }
  }
  get fullName() {
    return `${this.details.candidateInfo.firstName} ${
      this.details.candidateInfo.lastName
    }`;
  }

  forumImageUrl(fileId) {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.jobs.BrandingInfo.companycode}/forumpost/${fileId}`;
  }

  get postDate() {
    const createdDate = moment(this.details.createdDTTM);
    return createdDate.format('Do MMM [at] hh:mm a');
  }

  likePost(postId) {
    vxm.users.Rudderstack.trackEvent("Forum Post Liked", {
      forumPostId: postId,
    })
    vxm.forum.likePost(postId);
  }

  reFetchComments() {
    if (this.isHomePage) {
      this.$router.push('/post/' + this.details.postId);
      return;
    }
    this.showComment = !this.showComment;
    this.showOnlyThreeComments = true;
    if (!this.showComment) {
      return;
    }
    vxm.forum.listComments({ postId: this.details.postId, initCall: true });
  }

  loadComments(postId, initCall) {
    if (this.showOnlyThreeComments) {
      this.showOnlyThreeComments = false;
      return;
    }
    if (initCall) {
      this.showComment = true;
      this.showOnlyThreeComments = true;
    }
    vxm.forum.listComments({ postId, initCall });
  }

  get commentList() {
    if (this.showOnlyThreeComments) {
      return vxm.forum.CommentList.slice(0, 3).filter(
        (comment: any) =>
          comment.candidateInfo.candidateId ===
            vxm.users.myUserProfile.userId || comment.status !== 8,
      );
    }
    return vxm.forum.CommentList.filter(
      (comment: any) =>
        comment.candidateInfo.candidateId === vxm.users.myUserProfile.userId ||
        comment.status !== 8,
    );
  }

  get canShowLoadMoreComments() {
    return (
      vxm.forum.ShowLoadMoreComments ||
      (this.showOnlyThreeComments && vxm.forum.CommentList.length > 3)
    );
  }

  get canShowSeeLessComments() {
    return vxm.forum.CommentList.length > 3 && !this.canShowLoadMoreComments;
  }

  get contentOnlyText() {
    return !this.details.body.match(/<a |<img |<p /);
  }
}
